import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router v6 preserves scroll position across navigations by default, which
// leaves you mid-page after following a link. Mounting this once inside <Router>
// resets scroll to the top on every path change (including back/forward), so
// every internal navigation starts at the top.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
